import type { NotificationItem } from 'common/core/components/NotifyBar/NotifyInterfaces'
import { EMPTY_ARRAY } from 'shared/constants/empty'

export const getBackendNotifications = (state: RootState): readonly NotificationItem[] =>
  state.app.notifications ?? EMPTY_ARRAY
